<template>
  <div class="layer-duration" v-on:click.stop>
    <input class="tb-input sm" ref="duration" name="duration" v-model.lazy="time">
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      required: true,
    },
  },

  computed: {
    time: {
      get() {
        const minutes = Math.floor(this.duration / 60000);
        const seconds = ((this.duration % 60000) / 1000).toFixed(0);

        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      },

      set(value) {
        let num;
        if (value.indexOf(':') !== -1) { // if they pass in a format like "0:05"
          num = value.split(':');
          const minMillis = +num[0] * 60 * 1000;
          const secondMillies = +num[1] * 1000;

          if (Number.isNaN(minMillis) || Number.isNaN(secondMillies)) {
            this.$refs.duration.value = this.time;
            return;
          }

          this.$emit('update:duration', minMillis + secondMillies);
        } else { // otherwise just assume its seconds "5"
          if (Number.isNaN(value)) {
            this.$refs.duration.value = this.time;
            return;
          }

          this.$emit('update:duration', value * 1000);
        }

        this.$refs.duration.blur();

        this.$store.dispatch('updateTimeline');
        this.$store.dispatch('updatePreviewTimeline');
      },
    },
  },
};
</script>
